import { useEffect, useState } from 'react';
import { VehicleType } from '../models/vehicleType';
import { Call } from '../models/call';
import { getDepartureDisplayTime } from '../utils/departureDisplayTime';
import { getArrivalDisplayTime } from '../utils/arrivalDisplayTime';

function getCallDisplayTime(
  call: Call,
  vehicleType: VehicleType,
): string | undefined {
  switch (call.type) {
    case 'awaiting-departure':
      return getDepartureDisplayTime(call.departureTime, vehicleType);
    case 'upcoming':
    case 'delayed':
      return getArrivalDisplayTime(call.arrivalTime, vehicleType);
    case 'cancelled':
    case 'passed':
    case 'basic':
      return undefined;
  }
}

export default function useCallDisplayTime(
  call: Call,
  vehicleType: VehicleType,
) {
  const [displayTime, setDisplayTime] = useState<string | undefined>();

  useEffect(() => {
    const newDisplayTime = getCallDisplayTime(call, vehicleType);
    if (!newDisplayTime) {
      return;
    }

    setDisplayTime(newDisplayTime);

    const intervalId = setInterval(() => {
      setDisplayTime(getCallDisplayTime(call, vehicleType));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [call, vehicleType]);

  return displayTime;
}
